import { Injectable, ApplicationRef, ComponentFactoryResolver, Injector, EmbeddedViewRef, ReflectiveInjector } from '@angular/core';
import { NotificationComponent } from '@components/notification/notification.component';
import {ComponentFactory} from "@angular/core/src/linker/component_factory";

@Injectable()
export class NotificationService {
  notificationComponentFactory: ComponentFactory<NotificationComponent>;

  constructor(private app: ApplicationRef, private injector: Injector, private resolver: ComponentFactoryResolver) {
    this.notificationComponentFactory = this.resolver.resolveComponentFactory(NotificationComponent);
  }

  show(type:string, message:string) {
    const componentRef = this.notificationComponentFactory.create(this.injector);

    componentRef.instance.type = type;
    componentRef.instance.message = message;
    componentRef.instance.componentRef = componentRef;

    this.app.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    document.body.appendChild(domElem);

    return componentRef;
  }

  destroy(componentRef) {
    this.app.detachView(componentRef);
    componentRef.destroy();
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/core/notification/notification.service.ts